export default __webpack_public_path__ + "static/media/Jong_crop.4ae6a2d1.jpg";